import * as d3 from 'd3'

export default {

  methods: {

    set_LocalValues(){

      this.chartData = JSON.parse(JSON.stringify(this.DataItems))
      this.cutoff = JSON.parse(JSON.stringify(this.Queries.SQL1[0].CUTOFF))
      
      let json = JSON.parse(JSON.stringify(this.JQueries))

      //##### JSON #####
      this.title      = json.title
      this.timeline   = json.timeline
      this.primary    = json.primary
      this.secondary  = json.secondary
      this.chart      = json.chart
      this.legends    = json.legends
      this.sundries   = json.sundries
      this.keys       = json.keys
      this.filters    = json.filters

      this.timeline = {...this.timeline,
        week : [],
        month: [],
        year: [],
        axis: null,
        band: null,
      }
      this.primary.axis = null
      this.primary.max = null
      this.secondary.axis = null
      this.secondary.max = null


      // Setting Timeline ----------------------------
      this.timeline.axis = d3.scaleBand()
      .domain(this.chartData.map(d => d.CDATE ))
      .range([0, this.chart.width])
      this.timeline.band = this.timeline.axis.bandwidth()

      this.gmx_BandScaleValues_Week(this.chartData)

      // Set Coordinates for Bar X -------------------
      this.chartData.forEach((d,i)=> {
        d.bxs = this.gmx_BarCoordinates(d.mx, [...this.chart.styles.filter(f=> f.type=='BAR').map(m => m.size)], this.chart.barGap)
      })
      

      //
      //
      //
      //
      //


      // Setting Primary --------------------------------------------------------
      let maxArray = []
      this.chart.styles.filter(f=> f.type == 'BAR').forEach((s,i)=> {
        maxArray.push(d3.max(this.chartData, c => c[s.code]))
      })

      this.primary.max = d3.max(maxArray)
      if(this.chart.grid == 3) this.primary.max = (this.primary.max == 0) ? this.chart.grid : this.gmx_maxBound3(this.primary.max)
      if(this.chart.grid == 5) this.primary.max = (this.primary.max == 0) ? this.chart.grid : this.gmx_maxBound5(this.primary.max)

      this.primary.axis = d3.scaleLinear()
      .domain([0, this.primary.max])
      .range([0, this.chart.height])

      if(this.primary.position == 'left') this.primary.titleX = -this.primary.padding
      if(this.primary.position == 'right') this.primary.titleX = this.chart.width + this.primary.padding



      // Setting secondary ------------------------------------------------------
      maxArray = []
      this.chart.styles.filter(f=> f.type == 'LINE').forEach((s,i)=> {
        maxArray.push(d3.max(this.chartData, c => c[s.code]))
      })

      this.secondary.max = d3.max(maxArray)
      if(this.chart.grid == 3) this.secondary.max = (this.secondary.max == 0) ? this.chart.grid : this.gmx_maxBound3(this.secondary.max)
      if(this.chart.grid == 5) this.secondary.max = (this.secondary.max == 0) ? this.chart.grid : this.gmx_maxBound5(this.secondary.max)

      this.secondary.axis = d3.scaleLinear()
      .domain([0, this.secondary.max])
      .range([this.chart.height, 0])

      if(this.secondary.position == 'left') this.secondary.titleX = -this.secondary.padding
      if(this.secondary.position == 'right') this.secondary.titleX = this.chart.width + this.secondary.padding
    },


  }
}